import { Component, Input } from '@angular/core';

@Component({
	// TODO: OnPush prevents `top-bar-schedule-pass`, `top-bar-create-pass` from
	// updating when changing screen size changeDetection:
	// ChangeDetectionStrategy.OnPush,
	selector: 'sp-top-nav-bar',
	template: `<div class="logo-and-search">
			<app-smartpass-search></app-smartpass-search>
		</div>
		<div class="nav-buttons">
			<sp-nav-tabs role="navigation"></sp-nav-tabs>
		</div>
		<div class="action-buttons">
			<top-bar-schedule-pass></top-bar-schedule-pass>
			<top-bar-create-pass></top-bar-create-pass>
			<settings-nav-bar></settings-nav-bar>
		</div> `,
	styleUrls: ['./top-nav-bar.component.scss'],
	host: {
		'[class.contained]': 'isContained',
	},
})
export class TopNavBarComponent {
	@Input() isContained = false;
}
